import React, { useState } from "react";
import {
    Typography,
    Grid,
    Card,
    CardActions,
    CardMedia,
    CardContent,
    IconButton,
    Box,
} from "@mui/material";
import HighlightOff from "@mui/icons-material/HighlightOff";
import dayjs from "dayjs";
import NotificationPopup from "../../../component/popup/NotificationPopup";

const formatDate = (date) => {
    if (!date) return "";
    return dayjs(date).format("YYYY/MM/DD");
};
const UploadPhoto = ({
    title,
    images,
    onDelete,
    cardContent = (image) => (
        <>
            <Typography>{image.uploadedBy}</Typography>
            <Typography>- {formatDate(image.date)}</Typography>
        </>
    ),
    onSitePhotoClick,
    onLocalFileChange,
    sitePhotoLabel = "Upload from Project site photo library",
    localFileLabel = "Upload local file",
    readonly = false,
    allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/bmp",
        "image/tiff",
        "image/webp"
    ],
}) => {
    const [message, setMessage] = useState("");
    const handleLocalFileChange = (event) => {
        const files = event.target.files;
        for (let file of files) {
            if (!allowedTypes.includes(file.type)) {
                setMessage(`Upload Failed: File "${file.name}" has an unsupported format.`);
                return;
            }
        }
        setMessage("");
        onLocalFileChange(event);
    };

    return (
        <Box>
            {title && (
                <Typography variant="h5" my={1} fontWeight={600}>
                    {title}
                </Typography>
            )}
            <Grid container spacing={2} sx={{ mb: 1.5 }}>
                {images.map((image, index) => (
                    <Grid item xl={3} md={4} sm={6} key={index}>
                        <Card
                            sx={{
                                backgroundColor: "#F8F8F8",
                                cursor: "pointer",
                                width: "100%",
                                transition: "transform 0.2s, box-shadow 0.2s",
                                "&:hover": {
                                    transform: "scale(1.01)",
                                    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.2)",
                                },
                            }}
                        >
                            <CardActions
                                sx={{
                                    py: 0,
                                    pr: 0,
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontWeight: 600,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        minWidth: "80px",
                                        maxWidth: "200px",
                                    }}
                                    title={image.name}
                                >
                                    {image.name}
                                </Typography>
                                {!readonly && (
                                    <IconButton
                                        size="small"
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            if (onDelete) {
                                                onDelete(index);
                                            }
                                        }}
                                    >
                                        <HighlightOff />
                                    </IconButton>
                                )}
                            </CardActions>

                            <CardMedia
                                image={image.url}
                                title={image.name}
                                sx={{ height: 120, mx: 1, borderRadius: "5px" }}
                            />

                            <CardContent
                                sx={{
                                    textAlign: "right",
                                    pt: 1,
                                    pb: "8px!important",
                                    color: "#717273",
                                }}
                            >
                                {cardContent(image)}
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            {!readonly && (
                <Box sx={{ display: "flex", mt: 2 }}>
                    <Box
                        onClick={onSitePhotoClick}
                        sx={{
                            flex: 1,
                            border: "1px solid #CCC",
                            cursor: "pointer",
                            textAlign: "center",
                            py: 4,
                            px: 2,
                            borderRadius: "4px",
                            "&:hover": {
                                backgroundColor: "#F8F8F8",
                            },
                        }}
                    >
                        <img src="assets/illustrations/upload.svg" alt="Upload" />
                        <Typography variant="body1" my={1.5} fontWeight={700}>
                            {sitePhotoLabel}
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            flex: 1,
                            border: "1px solid #CCC",
                            cursor: "pointer",
                            textAlign: "center",
                            py: 4,
                            px: 2,
                            pt: 6,
                            borderRadius: "4px",
                            position: "relative",
                            "&:hover": {
                                backgroundColor: "#F8F8F8",
                            },
                        }}
                        component="label"
                    >
                        <img src="assets/illustrations/macbook.svg" alt="Upload" />
                        <Typography variant="body1" my={1.5} fontWeight={700}>
                            {localFileLabel}
                        </Typography>
                        <input
                            type="file"
                            accept={allowedTypes.join(",")}
                            multiple
                            hidden
                            onChange={handleLocalFileChange}
                        />
                    </Box>
                </Box>
            )}
            <NotificationPopup
                open={!!message}
                onClose={() => setMessage("")}
                title="Warning"
                message={message}
                iconSrc="assets/icons/error.svg"
                buttonLabel="Close"
                variant="error"
            />
        </Box>
    );
};

export default UploadPhoto;
